/*
 *
 * Adjustments constants
 *
 */

export const BASE_ACTION_CONSTANT = 'app/Adjustments';

export const DEFAULT_ACTION = `${BASE_ACTION_CONSTANT}/DEFAULT_ACTION`;

export const SEARCH_ADJUSTMENTS = `${BASE_ACTION_CONSTANT}/SEARCH_ADJUSTMENTS`;

export const SAVE_ADJUSTMENTS = `${BASE_ACTION_CONSTANT}/SAVE_ADJUSTMENTS`;

export const UPDATE_TABLE_DATA = `${BASE_ACTION_CONSTANT}/UPDATE_TABLE_DATA`;

export const RESET_FILTERS = `${BASE_ACTION_CONSTANT}/RESET_FILTERS`;

export const UPDATE_FILTERS = `${BASE_ACTION_CONSTANT}/UPDATE_FILTERS`;

export const RESET_PAGE = `${BASE_ACTION_CONSTANT}/RESET_PAGE`;

export const DISABLE_LOADER = `${BASE_ACTION_CONSTANT}/DISABLE_LOADER`;

export const ENABLE_LOADER = `${BASE_ACTION_CONSTANT}/ENABLE_LOADER`;

export const ADJUST_BALANCE = `${BASE_ACTION_CONSTANT}/ADJUST_BALANCE`;

export const EXPORT_TO_CSV = `${BASE_ACTION_CONSTANT}/EXPORT_TO_CSV`;

export const VENDOR_DATA_BY_ID = `${BASE_ACTION_CONSTANT}/VENDOR_DATA_BY_ID`;
export const SAVE_VENDOR_DATA_BY_ID = `${BASE_ACTION_CONSTANT}/SAVE_VENDOR_DATA_BY_ID`;

export const RESET_DATA = `${BASE_ACTION_CONSTANT}/RESET_DATA`;

export const EASY_SPLIT_REFUNDS = 'Easy-Split Refunds';

export const EASY_SPLIT_ADJUSTMENTS = 'Easy-Split Adjustments';

export const HEADINGS = {
  [EASY_SPLIT_REFUNDS]: [
    {
      key: 'initiatedAt',
      displayName: 'Initiated At',
      width: 0.15,
      tooltip: {
        message: 'Refunds Created On',
      },
    },
    {
      key: 'orderId',
      displayName: 'Order ID',
      width: 0.15,
    },
    {
      key: 'refundAmount',
      displayName: 'Refund Amt.',
      width: 0.15,
      align: 'right',
    },
    {
      key: 'refundId',
      displayName: 'Refund Id',
      width: 0.15,
    },
    {
      key: 'cfRefundId',
      displayName: 'CF Refund Id',
      width: 0.15,
    },
    {
      key: 'refundARN',
      displayName: 'Refund ARN',
      width: 0.15,
    },
    {
      key: 'phoneNumber',
      displayName: 'Phone No.',
      width: 0.15,
    },
    {
      key: 'paymentMode',
      displayName: 'Payment Mode',
      width: 0.15,
    },
    {
      key: 'refundStatus',
      displayName: 'Status',
      width: 0.15,
      align: 'left',
    },
  ],
  [EASY_SPLIT_ADJUSTMENTS]: [
    {
      key: 'createdAt',
      displayName: 'Date & Time',
      width: 0.15,
      tooltip: {
        message: 'Adjustment Created On',
      },
    },
    {
      key: 'adjustmentId',
      displayName: 'Adjustment ID',
      width: 0.15,
    },
    {
      key: 'creditDebit',
      displayName: 'Credit/Debit',
      width: 0.1,
    },
    {
      key: 'transferAmount',
      displayName: 'Transfer Amount',
      width: 0.1,
      align: 'right',
    },
    {
      key: 'remark',
      displayName: 'Remark',
      width: 0.2,
    },
  ],
};

export const ADJUSTMENT_TYPE = [
  {
    name: 'type',
    label: 'Debit',
    value: 'DEBIT',
  },
  {
    name: 'type',
    label: 'Credit',
    value: 'CREDIT',
  },
];

export const VENDOR_TYPE_PG = 'PG';

export const VENDOR_TYPE = {
  [VENDOR_TYPE_PG]: 'PG',
  LENDER: 'LENDING_SERVICE',
};

export const SEARCH_EASY_SPLIT_ADJUSTMENTS_URL = {
  url: '/pg/split/adjustments/search',
  method: 'GET',
};

export const ADJUST_BALANCE_URL = {
  url: '/pg/settlements/split/vendors-balance/$merchant_vendor_id$',
  method: 'POST',
};

export const EASY_SPLIT_REFUNDS_DATA_MAPPER = {
  adjustmentType: 'Adjustment Type',
  arn: 'ARN',
  customerPhone: 'Customer Phone',
  eventAmount: 'Event Amount',
  eventId: 'Event Id',
  eventTime: 'Event Time',
  eventType: 'Event Type',
  merchantRefundId: 'Merchant Refund Id',
  orderId: 'Order Id',
  paymentMode: 'Payment Mode',
  refundAddedOn: 'Refund Added On',
  refundAmount: 'Refund Amount',
  refundStatus: 'Refund Status',
  remarks: 'Remarks',
};

export const REFUND_STATUS_MAPPER = {
  '': 'PENDING',
  C: 'CANCELLED',
  S: 'REFUNDED',
  X: 'ONHOLD',
  H: 'ONHOLD',
};
